import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
  SimpleChanges,
  CSP_NONCE,
} from '@angular/core';
import {
  AcLineType,
  CustomerTariffScope,
  EditAcLineSegment,
  FeederBand,
  SelectAcLineDto,
  SelectCustomerTariffDto,
  SelectFeederBandDto,
} from '../../../../../models/ac-line-segment.model';
import { Voltage } from '../../../../../enums/voltage';
import { GeographicalRegion } from '../../../../../models/geographical-region.model';
import { SubstationTemplateForSelectDataOut } from '../../../../../models/substation-template.model';
import {
  SearchSubstationDto,
  SelectSubstationDto,
} from '../../../../../models/substation-template-instance.model';
import { GeographicalRegionService } from '../../../../../services/geographical-region.service';
import { ToastrService } from 'ngx-toastr';
import { CimSubstationService } from '../../../../../services/cim-substation.service';
import { PowerTransformerService } from '../../../../../services/power-transformer.service';
import { SelectPowerTransformerDto } from '../../../../../models/power-transformer.model';
import { AcLineSegmentService } from '../../../../../services/ac-line-segment.service';
import { ObjectDropdownComponent } from '../../../../common/object-dropdown/object-dropdown.component';
import { EnumDropdownComponent } from '../../../../common/enum-dropdown/enum-dropdown.component';
import { PermissionsService } from '../../../../../services/permissions.service';
import { MeterBrand } from '../../../../../models/meter-brand.model';
import { MeterBrandService } from '../../../../../services/meter-brand.service';

@Component({
  selector: 'lib-nec-add-edit-modal-ac-line-segment',
  templateUrl: './nec-add-edit-modal-ac-line-segment.component.html',
  styleUrls: [
    './nec-add-edit-modal-ac-line-segment.component.scss',
    '../../../network-entity-classes.component.scss',
  ],
  standalone: false,
})
export class NecAddEditModalAcLineSegmentComponent implements OnInit {
  @ViewChild('closeEditModal') closeEditModal?: ElementRef;
  @Output() acLineSegmentSaved = new EventEmitter<void>();
  @Input() isOpenedFromSubstation: boolean = false;
  @Input() selectedAcLineSegmentId: { value: number | null } | null = null;
  @Input() substationId: any;
  @Input() substationTemplateOptions: SubstationTemplateForSelectDataOut[] = [];
  @Input() isBoundary: boolean = false;
  @Input() boundaryId?: number;
  @Input() module: string = '';

  @ViewChild('instanceCategoryDropdown')
  instanceCategoryDropdown!: EnumDropdownComponent;
  @ViewChild('voltageDropdown') voltageDropdown!: EnumDropdownComponent;
  @ViewChild('parentSubstationDropdown')
  parentSubstationDropdown!: ObjectDropdownComponent;
  @ViewChild('assetNameDropdown') assetNameDropdown!: ObjectDropdownComponent;
  @ViewChild('powerTransformerDropdown')
  powerTransformerDropdown!: ObjectDropdownComponent;
  @ViewChild('regionDropdown') regionDropdown!: ObjectDropdownComponent;
  @ViewChild('poweparentAcLineDropdownrTransformerDropdown')
  parentAcLineDropdown!: ObjectDropdownComponent;
  @ViewChild('feederBandDropdown')
  feederBandDropdown!: ObjectDropdownComponent;
  @ViewChild('customerTariffDropdown')
  customerTariffDropdown!: ObjectDropdownComponent;
  @ViewChild('meterBrandDropdown')
  meterBrandDropdown!: ObjectDropdownComponent;

  isEdit: boolean = false;
  Voltage = Voltage;
  AcLineType = AcLineType;
  initialAcLineType: AcLineType | null = AcLineType.Incoming;
  geographicalRegionValue: GeographicalRegion | null = null;
  substationTemplateValue: SubstationTemplateForSelectDataOut | null = null;
  geoRegions: GeographicalRegion[] = [];
  substationOptions: SelectSubstationDto[] = [];
  powerTransformerOptions: SelectPowerTransformerDto[] = [];
  parentAcLineOptions: SelectAcLineDto[] = [];
  dataIn: SearchSubstationDto = new SearchSubstationDto();
  selectedAcLineSegment: EditAcLineSegment = new EditAcLineSegment();
  editModeRegion?: string;
  bandOptions: SelectFeederBandDto[] = [
    { id: FeederBand.BandA, name: 'Band A' },
    { id: FeederBand.BandB, name: 'Band B' },
    { id: FeederBand.BandC, name: 'Band C' },
    { id: FeederBand.BandD, name: 'Band D' },
    { id: FeederBand.BandE, name: 'Band E' },
  ];
  selectedBandOption: SelectFeederBandDto | null = null;
  customerTariffOptions: SelectCustomerTariffDto[] = [
    { id: CustomerTariffScope.Prepaid, name: 'Prepaid' },
    { id: CustomerTariffScope.Postpaid, name: 'Postpaid' },
    { id: CustomerTariffScope.Both, name: 'Both' },
  ];
  selectedCustomerTariffOption: SelectCustomerTariffDto | null = null;
  feederBandChanged: boolean = false;
  displayBaseVoltage: boolean = false;
  baseVoltage: string = '';
  powerTransformerName?: string;
  acLineName?: string;
  selectedSubstationTemplate: number = 0;
  substationTemplateVoltage?: Voltage;
  substationTemplateInstanceValue: SelectSubstationDto | null = null;
  powerTransformerInitialValue: SelectPowerTransformerDto | null = null;
  parentAcLineInstanceValue: SelectAcLineDto | null = null;
  hasBand: boolean = false;
  meterBrands: MeterBrand[] = [];
  meterBrandValue: MeterBrand | null = null;
  updatedRegionId: number | null = 0;

  mapStringToAcLineType(acLineSegmentTypeString: string): AcLineType {
    const acLineSegmentTypeMap: { [key: string]: AcLineType } = {
      Incoming: AcLineType.Incoming,
      Outgoing: AcLineType.Outgoing,
    };

    return acLineSegmentTypeMap[acLineSegmentTypeString] || AcLineType.Incoming;
  }

  constructor(
    private geographicalRegionService: GeographicalRegionService,
    private toastr: ToastrService,
    private cimSubstationService: CimSubstationService,
    private powerTransformerService: PowerTransformerService,
    private acLineSegmentService: AcLineSegmentService,
    private permissionsService: PermissionsService,
    private meterBrandService: MeterBrandService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const change = changes['selectedAcLineSegmentId'];
    if (!change) return;

    const newValue = change.currentValue;

    if (newValue && newValue.value !== 0) {
      this.isEdit = true;
      this.getById(newValue.value);
    } else {
      this.isEdit = false;
      this.resetForm();
    }
  }

  ngOnInit(): void {
    this.getAllGeographicalRegionsForSelect();
    if (!this.isOpenedFromSubstation) {
      this.getAllMeterBrandsForSelect();
    }
    this.initializeForm();
    if (
      this.selectedAcLineSegmentId !== null &&
      this.selectedAcLineSegmentId.value !== null &&
      this.selectedAcLineSegmentId.value !== 0
    ) {
      this.isEdit = true;
      this.getById(this.selectedAcLineSegmentId.value);
    }

    this.hasBand =
      this.permissionsService.hasDashboardConfigFeederBands && !this.isBoundary;
  }

  initializeForm(): void {
    this.selectedAcLineSegment = new EditAcLineSegment();
    this.selectedAcLineSegment.acLineType = AcLineType.Incoming;
  }

  onAcLineSegmentTypeChanged(obj: AcLineType): void {
    this.selectedAcLineSegment.acLineType = obj;
  }

  save(): void {
    if (
      !this.selectedAcLineSegment.name ||
      this.selectedAcLineSegment.name.trim() === ''
    ) {
      this.toastr.warning('Instance Name is required');
      return;
    }

    if (
      !this.selectedAcLineSegment.number ||
      this.selectedAcLineSegment.number === ''
    ) {
      this.toastr.warning('Number is required');
      return;
    }

    if (
      this.feederBandChanged &&
      !this.selectedAcLineSegment.customerTariffScope
    ) {
      this.toastr.warning('Customer Type is required');
      return;
    }

    if (!this.isEdit) {
      if (
        !this.selectedAcLineSegment.parentSubstationId ||
        this.selectedAcLineSegment.parentSubstationId === 0
      ) {
        this.toastr.warning('Parent Substation is required');
        return;
      }

      if (
        !this.isBoundary &&
        (!this.selectedAcLineSegment.powerTransformerId ||
          this.selectedAcLineSegment.powerTransformerId === 0)
      ) {
        this.toastr.warning('Power Transformer is required');
        return;
      }
    }

    const payload = {
      id: !this.isBoundary
        ? this.selectedAcLineSegment.id
        : this.selectedAcLineSegment.boundaryId,
      name: this.selectedAcLineSegment.name.trim(),
      acLineType: this.selectedAcLineSegment.acLineType,
      number: this.selectedAcLineSegment.number.toString(),
      parentSubstationId: this.selectedAcLineSegment.parentSubstationId,
      powerTransformerId: this.selectedAcLineSegment.powerTransformerId,
      parentAcLineId: this.selectedAcLineSegment.parentAcLineId,
      feederBand: this.selectedAcLineSegment.feederBand,
      module: this.module,
      customerTariffScope: this.selectedAcLineSegment.customerTariffScope,
      meterNumber: this.selectedAcLineSegment.meterNumber,
      meterBrandId: this.selectedAcLineSegment.meterBrandId,
      latitude: this.selectedAcLineSegment.latitude,
      longitude: this.selectedAcLineSegment.longitude,
    };

    this.acLineSegmentService.create(payload).subscribe({
      next: (response: any) => {
        if (response.body.status == 'OK') {
          this.toastr.success(response.body.message);
        } else {
          this.toastr.warning(response.body.message);
        }
        this.resetForm();
        this.closeEditModal?.nativeElement?.click();
        this.acLineSegmentSaved.emit();
      },
      error: (error) => {
        this.toastr.error(
          error?.error?.message ||
            `Error ${this.isEdit ? 'updating' : 'saving'} AC Line Segment`,
        );
      },
    });
  }

  resetForm(): void {
    this.isEdit = false;
    this.substationTemplateValue = null;
    this.substationTemplateInstanceValue = null;
    this.powerTransformerInitialValue = null;
    this.parentAcLineInstanceValue = null;
    this.substationOptions = [];
    this.powerTransformerOptions = [];
    this.selectedSubstationTemplate = 0;
    this.selectedBandOption = null;
    this.selectedCustomerTariffOption = null;
    this.feederBandChanged = false;
    this.substationTemplateVoltage = undefined;

    this.baseVoltage = '';

    this.editModeRegion = undefined;

    this.instanceCategoryDropdown?.selectOption({
      key: AcLineType.Incoming.toString(),
      label: 'Incoming',
    });
    this.voltageDropdown?.selectOption({
      key: Voltage.LV.toString(),
      label: 'LV',
    });
    this.parentSubstationDropdown?.selectItem(null);
    this.assetNameDropdown?.selectItem(null);
    this.powerTransformerDropdown?.selectItem(null);
    this.regionDropdown?.selectItem(null);
    this.parentAcLineDropdown?.selectItem(null);
    this.feederBandDropdown?.selectItem(null);
    this.customerTariffDropdown?.selectItem(null);
    this.meterBrandDropdown?.selectItem(null);
    this.displayBaseVoltage = false;
    this.selectedAcLineSegment.id = null;
    this.selectedAcLineSegment.name = '';
    this.selectedAcLineSegment.number = '';
    this.selectedAcLineSegment.parentSubstationId = 0;
    this.selectedAcLineSegment.powerTransformerId = 0;
    this.selectedAcLineSegment.parentAcLineId = undefined;
    this.selectedAcLineSegment.feederBand = undefined;
    this.selectedAcLineSegment.meterNumber = '';
    this.selectedAcLineSegment.meterBrandId = undefined;
    this.selectedAcLineSegment.latitude = undefined;
    this.selectedAcLineSegment.longitude = undefined;
    this.meterBrandValue = null;

    if (this.isOpenedFromSubstation) {
      this.selectedAcLineSegment.parentSubstationId = this.substationId;
      this.getAllPowerTransformers(this.substationId);
    }

    this.hasBand =
      this.permissionsService.hasDashboardConfigFeederBands && !this.isBoundary;
  }

  getAllGeographicalRegionsForSelect(): void {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geoRegions = responseData.data.map(
            (geoRegion: GeographicalRegion) => ({
              ...geoRegion,
              isExpanded: false,
            }),
          );
        } else if (response?.status === 204) {
          this.geoRegions = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading regions');
      },
    });
  }

  onSelectSubstationTemplate(
    obj: SubstationTemplateForSelectDataOut | null,
  ): void {
    if (obj != null && obj.id != null) {
      this.selectedSubstationTemplate = obj.id;
      this.assetNameDropdown.selectItem(null);
      this.substationOptions = [];
      this.substationTemplateInstanceValue = null;
      this.powerTransformerOptions = [];
      this.powerTransformerInitialValue = null;
      this.selectedBandOption = null;
      this.selectedCustomerTariffOption = null;
      this.selectedAcLineSegment.customerTariffScope = undefined;
      this.feederBandChanged = false;
      this.parentAcLineInstanceValue = null;
      this.selectedAcLineSegment.parentSubstationId = 0;
      this.selectedAcLineSegment.powerTransformerId = 0;
      this.displayBaseVoltage = false;
      this.substationTemplateVoltage = obj.voltageClass;
    }

    console.log(this.substationTemplateVoltage);
  }

  onSelectSubstationTemplateInstance(
    obj: SelectSubstationDto | null,
    ptName: string = '',
    updateRegions: boolean = false,
  ): void {
    if (obj?.id) {
      this.editModeRegion = updateRegions ? obj.region : this.editModeRegion;
      this.selectedAcLineSegment.parentSubstationId = obj.id;
      this.powerTransformerOptions = [];
      this.selectedAcLineSegment.powerTransformerId = 0;
      this.displayBaseVoltage = false;
      this.powerTransformerDropdown?.selectItem(null);
      if (this.isBoundary) this.getAllOutgoingLines();
      else {
        this.getAllPowerTransformers(obj.id, ptName);
        if (Voltage[this.substationTemplateVoltage?.toString() as keyof typeof Voltage] == Voltage.LV) {
          this.selectedBandOption = null;

          this.getMainFeederBand(obj.id);
        }
      }
    } else {
      this.selectedAcLineSegment.parentSubstationId = 0;
      this.powerTransformerOptions = [];
      this.powerTransformerInitialValue = null;
      this.selectedBandOption = null;
      this.selectedCustomerTariffOption = null;
      this.selectedAcLineSegment.customerTariffScope = undefined;
      this.feederBandChanged = false;
      this.parentAcLineInstanceValue = null;
      this.selectedAcLineSegment.powerTransformerId = 0;
      this.displayBaseVoltage = false;
    }
  }

  onSelectParentAcLineInstance(obj?: SelectAcLineDto | null | undefined): void {
    if (obj?.id) {
      this.selectedAcLineSegment.parentAcLineId = obj.id;
      this.baseVoltage = obj.baseVoltage;
      this.displayBaseVoltage = true;
    } else {
      this.selectedAcLineSegment.parentAcLineId = 0;
      this.displayBaseVoltage = false;
      this.baseVoltage = '';
    }
  }

  getAllPowerTransformers(substationId: number, ptName: string = ''): void {
    this.powerTransformerService
      .getAllPowerTransformersFromSubstationId(substationId)
      .subscribe({
        next: (response: any) => {
          this.powerTransformerInitialValue = null;

          const responseData = response;
          if (responseData?.status === 'OK') {
            this.powerTransformerOptions = responseData.data;
            if (ptName) {
              this.powerTransformerInitialValue =
                this.powerTransformerOptions.filter((x) => x.name == ptName)[0];
              this.selectedAcLineSegment.powerTransformerId =
                this.powerTransformerInitialValue.id!;
              this.onSelectPowerTransformer(this.powerTransformerInitialValue);
            }
          } else if (response?.status !== 'OK') {
            this.powerTransformerOptions = [];
          }
        },
        error: (error) => {
          this.toastr.error(
            'Error occurred while loading power transformer options',
          );
        },
      });
  }

  getMainFeederBand(substationId: number): void {
    this.cimSubstationService.getMainFeederBand(substationId).subscribe({
      next: (response: any) => {
        const responseData = response;
        if (responseData?.status === 200) {
          console.log('dobio sam odgovor');
          this.selectedBandOption =
            this.bandOptions.find((x) => x.id == responseData.body.data) ||
            null;
          console.log(this.selectedBandOption);
        }
      },
      error: (error) => {
        this.toastr.error(
          'Error occurred while loading power transformer options',
        );
      },
    });
  }

  onSearchTextChange(inputText: string): void {
    if (this.selectedSubstationTemplate > 0) {
      this.getAllSubstationInstancesForType(
        this.selectedSubstationTemplate,
        inputText,
      );
    }
  }

  getAllOutgoingLines() {
    this.cimSubstationService
      .getOutgoingLines(this.selectedAcLineSegment.parentSubstationId)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.parentAcLineOptions = responseData.data.map(
              (outgoingAcLineSegment: any) => ({
                ...outgoingAcLineSegment,
              }),
            );

            if (this.selectedAcLineSegment.parentAcLineId) {
              this.parentAcLineInstanceValue =
                this.parentAcLineOptions.find(
                  (x) => x.id == this.selectedAcLineSegment.parentAcLineId,
                ) ?? null;

              this.onSelectParentAcLineInstance(this.parentAcLineInstanceValue);
            }
          } else if (response?.status === 204) {
            this.parentAcLineOptions = [];
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error(
            'Error occurred while loading outgoing ac line segments',
          );
        },
      });
  }

  getAllSubstationInstancesForType(
    templateId: number,
    searchTerm: string = '',
    substationName: string = '',
    ptName: string = '',
  ): void {
    this.dataIn.templateId = templateId;
    this.dataIn.searchTerm = searchTerm;
    this.cimSubstationService.getAllForSelect(this.dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK') {
          this.substationOptions = responseData.data;
          if (substationName) {
            this.substationTemplateInstanceValue =
              this.substationOptions.filter((x) => x.name == substationName)[0];
            this.selectedAcLineSegment.parentSubstationId =
              this.substationTemplateInstanceValue.id!;
            this.onSelectSubstationTemplateInstance(
              this.substationTemplateInstanceValue,
              ptName,
            );
          }
        } else if (response?.status !== 'OK') {
          this.substationOptions = [];
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while loading substation options');
      },
    });
  }

  onSelectPowerTransformer(obj: SelectPowerTransformerDto | null): void {
    if (obj?.id) {
      this.selectedAcLineSegment.powerTransformerId = obj.id;
      this.baseVoltage = obj.baseVoltage;
      this.displayBaseVoltage = true;
      this.powerTransformerName = obj.name;
    } else {
      this.selectedAcLineSegment.powerTransformerId = 0;
      this.displayBaseVoltage = false;
      this.baseVoltage = '';
      this.powerTransformerName = '';
    }
  }

  onSelectFeederBand(obj: SelectFeederBandDto | null): void {
    // Customer Tariff is a one-off update trigger, never prepopulated; reset it whenever the band changes.
    this.selectedCustomerTariffOption = null;
    this.selectedAcLineSegment.customerTariffScope = undefined;
    this.customerTariffDropdown?.selectItem(null);

    if (obj?.id) {
      this.selectedAcLineSegment.feederBand = obj.id;
      this.feederBandChanged = true;
    } else {
      this.selectedAcLineSegment.feederBand = undefined;
      this.feederBandChanged = false;
    }
  }

  onSelectCustomerTariff(obj: SelectCustomerTariffDto | null): void {
    if (obj?.id) {
      this.selectedAcLineSegment.customerTariffScope = obj.id;
    } else {
      this.selectedAcLineSegment.customerTariffScope = undefined;
    }
  }

  getAllMeterBrandsForSelect(): void {
    this.meterBrandService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterBrands = responseData.data;
          this.meterBrandValue =
            this.meterBrands.find(
              (b) => b.id === this.selectedAcLineSegment.meterBrandId,
            ) ?? null;
        } else if (response?.status === 204) {
          this.meterBrands = [];
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while loading meter brands');
      },
    });
  }

  onSelectMeterBrand(obj: MeterBrand | null): void {
    this.selectedAcLineSegment.meterBrandId = obj?.id ?? undefined;
  }

  onSelectGeographicalRegion(obj: GeographicalRegion | null): void {
    if (obj) {
      this.updatedRegionId = obj.id;
    }
  }

  getById(selectedAcLineSegmentId: number): void {
    let dataIn = {
      id: selectedAcLineSegmentId,
      substationId: this.substationId,
      boundaryId: this.boundaryId,
      acLineType: this.isBoundary ? 'Boundary' : 'Default',
    };

    this.acLineSegmentService.getById(dataIn).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 'OK' && responseData?.data) {
          const data = responseData.data;
          this.substationTemplateValue = this.substationTemplateOptions.filter(
            (x) => x.className == data.className,
          )[0];
          if (this.substationTemplateValue) {
            this.selectedSubstationTemplate = this.substationTemplateValue.id!;
            this.getAllSubstationInstancesForType(
              this.selectedSubstationTemplate,
              data.substationName,
              data.substationName,
              data.powerTransformerSelect?.name,
            );
          }
          this.editModeRegion = data.suppliedRegions.join(', ');

          this.selectedAcLineSegment.id = data.id;
          this.selectedAcLineSegment.name = data.name || '';
          this.selectedAcLineSegment.number = data.number || '';
          this.selectedAcLineSegment.meterNumber = data.meterNumber || '';
          this.selectedAcLineSegment.meterBrandId = data.meterBrandId ?? undefined;
          this.selectedAcLineSegment.latitude = data.latitude ?? undefined;
          this.selectedAcLineSegment.longitude = data.longitude ?? undefined;
          this.meterBrandValue =
            this.meterBrands.find((b) => b.id === data.meterBrandId) ?? null;
          this.feederBandChanged = false;
          this.selectedCustomerTariffOption = null;
          this.selectedAcLineSegment.customerTariffScope = undefined;
          if (this.hasBand && data.feederBand) {
            this.selectedAcLineSegment.feederBand =
              FeederBand[data.feederBand as keyof typeof FeederBand];
            this.selectedBandOption = this.bandOptions.find(
              (x) => x.id === this.selectedAcLineSegment.feederBand,
            )!;
          } else {
            this.selectedBandOption = null;
          }

          this.selectedAcLineSegment.powerTransformerId =
            data.powerTransformerSelect?.id || 0;
          if (data.acLineType) {
            this.selectedAcLineSegment.acLineType = this.mapStringToAcLineType(
              data.acLineType,
            );
            this.initialAcLineType = data.acLineType;
            if (this.instanceCategoryDropdown) {
              const acLineTypeLabel = data.acLineType;
              this.instanceCategoryDropdown.selectOption({
                key: data.acLineType.toString(),
                label: acLineTypeLabel,
              });
            }
          }
          if (!this.isBoundary) {
            if (data.powerTransformerSelect?.baseVoltage) {
              this.baseVoltage = data.powerTransformerSelect.baseVoltage;
              this.displayBaseVoltage = true;
            }

            this.powerTransformerName = data.powerTransformerSelect?.name;
          } else {
            this.baseVoltage = data.acLineSelect.baseVoltage;
            this.displayBaseVoltage = true;
            this.acLineName = data.acLineSelect?.name;
            this.selectedAcLineSegment.parentAcLineId = data.id;
            this.selectedAcLineSegment.boundaryId = data.boundaryId;
          }
        }
      },
      error: (error) => {
        this.toastr.error('Error occurred while loading AC Line Segment data');
      },
    });
  }
}
